<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="公司名称"
        v-model.trim="companyName"
        class="handle-input mr10"
      ></el-input>
      <el-select size="small" v-model="unconfirmed" @change="search" class="mr10">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        size="small"
        v-model="reportType"
        @change="search"
        class="mr10"
      >
        <el-option
          v-for="item in type_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select size="small" v-model="scaleType" @change="search" class="mr10">
        <el-option
          v-for="item in company_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="220px" header-align="center" label="用户名称">
        <template #default="scope">
          <ul>
            <li>订单号：{{ scope.row.orderNo }}</li>
            <li>{{ scope.row.name }}</li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        align="center"
        label="报告类型"
        :formatter="formatType"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="realname"
        label="联系人"
      ></el-table-column>
      <el-table-column
        width="130px"
        prop="username"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column min-width="170" align="center" label="申请时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.applyTime, "yyyy-MM-dd hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="scaleType"
        align="center"
        label="企业规模"
        :formatter="formaScale"
      >
      </el-table-column>

      <el-table-column min-width="100px" align="center" label="支付金额">
        <template #default="scope">{{ scope.row.price }}元 </template>
      </el-table-column>
      <el-table-column min-width="120px" align="center" label="支付方式">
        <template #default="scope">
          <ul>
            <li>公司转账</li>
            <li>
              <el-button type="text" @click="payment(scope.row)"
                >查看转账信息</el-button
              >
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column width="90px" align="center" label="到账确认">
        <template #default="scope">
          <li class="overdue" v-if="scope.row.isPay === 0">未确认</li>
          <li class="rational" v-if="scope.row.isPay === 1">已到账</li>
        </template>
      </el-table-column>
      <el-table-column min-width="110" align="center" label="驳回时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.auditTime, "yyyy-MM-dd") }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template #default="scope">
          <el-button
            type="danger"
            size="mini"
            @click="
              itemData = scope.row;
              reason_dialog = true;
            "
            >驳回理由</el-button
          >
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="操作人">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 付款信息 -->
    <el-dialog
      v-model="payment_dialog"
      width="900px"
      title="付款信息"
      destroy-on-close
    >
      <div class="payment_dialog-body">
        <el-form size="mini" label-position="right" label-width="90px">
          <el-form-item label="付款账号：">{{
            itemData.payAccount
          }}</el-form-item>
          <el-form-item label="付款银行：">{{
            itemData.paymentBank
          }}</el-form-item>
          <el-form-item label="付款人：">{{ itemData.payer }}</el-form-item>
          <el-form-item label="付款时间：">{{ itemData.payTime }}</el-form-item>
          <el-form-item label="付款凭证："></el-form-item>
          <div v-if="itemData.paymentVoucher">
            <img
              :src="$utils.fileUrl(itemData.paymentVoucher)"
              v-if="
                $utils.fileType(itemData.paymentVoucher) === 'png' ||
                $utils.fileType(itemData.paymentVoucher) === 'jpg'
              "
              alt=""
            />
            <template v-else>
              <embed
                :src="$utils.fileUrl(itemData.paymentVoucher)"
                type="application/pdf"
              />
            </template>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="payment_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 驳回理由 -->
    <el-dialog
      v-model="reason_dialog"
      width="500px"
      title="驳回理由"
      destroy-on-close
    >
      <div class="reason_dialog-body">
        <p>{{ itemData.reportRemark }}</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="reason_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      companyName: "",
      unconfirmed: "",
      reportType: "",
      scaleType: "",
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "未确认",
        },
        {
          value: 1,
          label: "已到账",
        },
      ],
      type_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "履约报告",
        },
        {
          value: 2,
          label: "信贷报告",
        },
        {
          value: 3,
          label: "综合报告",
        },
      ],
      company_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "小微企业",
        },
        {
          value: 2,
          label: "中型企业",
        },
        {
          value: 3,
          label: "大型企业",
        },
      ],
      payment_dialog: false,
      reason_dialog: false,
      itemData: {},
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    search() {
      this.getData();
    },
    async getData(page = 1) {
      if (this.companyName.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          unconfirmed: this.unconfirmed,
          reportType: this.reportType,
          scaleType: this.scaleType,
          name: this.companyName,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.xinfuReport.noPass.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    formatType(row, column) {
      switch (row.type) {
        case 1:
          return "履约报告";
        case 2:
          return "信贷报告";
        case 3:
          return "综合报告";
      }
    },
    formaScale(row, column) {
      switch (row.scaleType) {
        case 1:
          return "小微企业";
        case 2:
          return "中型企业";
        case 3:
          return "大型企业";
      }
    },
    payment(data) {
      this.itemData = data;
      this.payment_dialog = true;
    },
  },
  watch: {
    companyName: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .el-select {
    width: 120px;
  }
}

.end {
  color: $--color-danger;
}

.overdue {
  color: $--color-danger;
}
.rational {
  color: $--color-success;
}

.preview-dialog {
  img {
    width: 100%;
  }
}

.payment_dialog-body {
  embed {
    width: 100%;
    height: 800px;
  }
  img {
    width: 100%;
  }
}

p {
  line-height: 24px;
  font-size: 0.875rem;
}
</style>